import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from '@auth0/auth0-angular';
import {ExtensionComponent} from "./public/extension/extension.component";
import {NoopComponent} from "./noop.component";
import {DebugComponent} from "./public/debug/debug.component";
import {ErrorComponent} from "./public/error/error.component";

const APP_ROUTES: Routes = [
  {
    path: 'public',
    pathMatch: 'prefix',
    children: [
      {
        path: 'extension',
        pathMatch: 'full',
        component: ExtensionComponent
      }, {
        path: 'debug',
        pathMatch: 'full',
        component: DebugComponent
      }, {
        path: 'error/:code',
        pathMatch: 'full',
        component: ErrorComponent
      }
    ]
  }, {
    path: '',
    pathMatch: 'full',
    canActivate: [AuthGuard],
    component: NoopComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(APP_ROUTES)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
